import { render, staticRenderFns } from "./provider-card.vue?vue&type=template&id=9f30871c&scoped=true&"
import script from "./provider-card.vue?vue&type=script&lang=js&"
export * from "./provider-card.vue?vue&type=script&lang=js&"
import style0 from "./provider-card.vue?vue&type=style&index=0&id=9f30871c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f30871c",
  null
  
)

export default component.exports